import styled from "styled-components";
import { breakpoints, maxWidth } from "../../variables/breakpoints";
import { colors } from "../../variables/colors";
import { fonts } from "../../variables/fonts";

export const Link = styled.a`
  font-family: ${fonts.nunito};
  margin-top: 1.5rem;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: ${colors.blue};
  padding-left: 2.5rem;
  background-repeat: no-repeat;
  background-size: 1rem;
  background-position: 0 40%;
  ${maxWidth(breakpoints.md)} {
    margin-top: 1rem;
  }
  ${maxWidth(breakpoints.sm)} {
    padding-left: 0;
    display: block;
  }
`;

export default Link;
